import { getToken, setToken, removeToken, getUserInfo, setUserInfo, removeUserInfo } from '@/utils/auth'

const state = {
  token: getToken() || '',
  userInfo: getUserInfo() || null
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    setToken(token)
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
    setUserInfo(userInfo)
  },
  REMOVE_TOKEN: (state) => {
    state.token = ''
    removeToken()
  },
  REMOVE_USER_INFO: (state) => {
    state.userInfo = null
    removeUserInfo()
  }
}

const actions = {
  logout({ commit }) {
    commit('REMOVE_TOKEN')
    commit('REMOVE_USER_INFO')
  }
}

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



